// import { Navigate } from "react-router-dom";

// export default function ProtectedRoute({ children, adminOnly = false }) {
//   const user = JSON.parse(localStorage.getItem("user"));

//   if (!user) {
//     return <Navigate to="/" />; // Redirect to public home if not logged in
//   }

//   if (adminOnly && user.role !== "admin") {
//     return <Navigate to="/user/dashboard" />; // Redirect to user panel if not admin
//   }

//   return children;
// }

import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRole }) => {
  const savedUser = localStorage.getItem("user");
  const user = savedUser ? JSON.parse(savedUser) : null;

  // 1. If not logged in, send to Home (where your login modal is)
  if (!user) {
    alert("Please login to access this page.");
    return <Navigate to="/" replace />;
  }

  // 2. If role doesn't match (e.g., user trying to enter admin panel)
  if (allowedRole && user.role !== allowedRole) {
    alert("Access Denied: Unauthorized Role.");
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
